import VehicleInformation from './VehicleInformation';
import TransactionInformation from './TransactionInformation';
import { useSelector } from 'react-redux';
import { selectDocsFormData } from '../../redux-state/selectors';
import { STATE_MAPPER } from '../docs/constants';
import { formatDate } from '../utility/formatDate';

function DocsOutputLeftSide() {
  const docsFormData = useSelector(selectDocsFormData)

  const getStateFullName = (abbr) => {
    return STATE_MAPPER[abbr] || abbr;
  };

  return (
    <div className='flex flex-col gap-4 w-[100%]'>
      <div className='flex flex-row text-gray-700 font-bold mb-2 items-center h-11'>
        Your Information
      </div>

      <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
        <div className='text-gray-700 mb-3 font-bold'>
          Location Information
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
          <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Zip Code:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.zipCode}
              </div>
            </div>

            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                City:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.city}
              </div>
            </div>

          </div>

          <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                State:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {getStateFullName(docsFormData?.state)}
              </div>
            </div>

            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                County:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.country}
              </div>
            </div>
          </div>
        </div>

        <VehicleInformation/>
        <TransactionInformation/>

        {(docsFormData?.insuranceCompany || docsFormData?.insuranceExpirationDate || docsFormData?.insuranceDate || docsFormData?.insurancePolicyNumber) &&
          <div>
            <div className='border-t-2 border-t-gray-100 mb-3'>
              <div className='text-gray-700 mt-6 font-bold'>
                Insurance Information
              </div>
            </div>

            <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
              <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Company:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {docsFormData?.insuranceCompany}
                  </div>
                </div>

                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Expiration Date:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {formatDate(docsFormData?.insuranceExpirationDate)}
                  </div>
                </div>
              </div>

              <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Date:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {formatDate(docsFormData?.insuranceDate)}
                  </div>
                </div>

                <div className='flex flex-row justify-between gap-2 items-start'>
                  <div>
                    Insurance Number:
                  </div>
                  <div className='font-medium text-right break-words min-w-0'>
                    {docsFormData?.insurancePolicyNumber}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default DocsOutputLeftSide;